// store/forms/samplingEventForm/filter/samplingEventWellsFiltersState.js
// Keeping a state active to add to different UI states for our sampling event form

export const samplingEventWellsFiltersInitialState = {
  isFilterMenuOpen: false,
  filters: {
    wellId: "",
    status: "",
    groupAssignment: "all", // Used by Wells/Sampling tab
    inspectionStatus: "all", // Used by Inspections tab ('all' | 'completed' | 'incomplete')
    samplingStatus: "all", // Used by for Sampling tab ('all' | 'completed' | 'incomplete')
  },
  sort: {
    field: "wellId",
    direction: "asc",
  },
};
